import { render, staticRenderFns } from "./LegacyPrintOptions.vue?vue&type=template&id=74d7b19e&scoped=true"
import script from "./LegacyPrintOptions.vue?vue&type=script&lang=js"
export * from "./LegacyPrintOptions.vue?vue&type=script&lang=js"
import style0 from "./LegacyPrintOptions.vue?vue&type=style&index=0&id=74d7b19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d7b19e",
  null
  
)

export default component.exports